//以旧换新管理相关 api
import request from "@/utils/request";
const baseService = "autoapp-default-server-recovery";
//小程序资讯模块 start
/**
 * @function  新增资讯
 * @property {object}  params - 请求参数.
 * @property {string}  params.outletsNo - 网点编码
 * @returns {Promise<object>}
 */

export function savePublish(data) {
  return request({
    url: `${baseService}/api/publish/savePublish`,
    method: "post",
    data
  });
}

/**
 * @function 编辑资讯
 * @returns {Promise<object>}
 */
export function updatePublish(data) {
  return request({
    url: `${baseService}/api/publish/updatePublish`,
    method: "post",
    data
  });
}

/**
 * @function 删除资讯
 * @returns {Promise<object>}
 */
export function delPublish(id) {
  return request({
    url: `${baseService}/api/publish/deletePublishId/${id}`,
    method: "delete"
  });
}

/**
 * @function 获取资讯列表
 * @returns {Promise<object>}
 */
export function getPublishList(data) {
  return request({
    url: `${baseService}/api/publish/pageCondition`,
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/mpManagement.js